import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/faqs/page.tsx");
